/* External */
import axios from 'axios';

/* Interceptors */
import { createClientIdInterceptor } from './interceptors/clientId';
import { createRealmPathInterceptor } from './interceptors/realmPath';
import { createDataSerializerInterceptor } from '../interceptors/dataSerializer';
import { createAuthenticationInterceptor } from '../interceptors/auth';

/**
 * @typedef ForgeRockAxiosInstanceCreatorParams
 * @type {object}
 * @property {string} apiToken
 * @property {import('../interceptors/forgerock/realmPath').GetIsBrazilCallback} getIsBrazil
 * @property {string} host
 * @property {string} [clientId]
 */

/**
 * @param {ForgeRockAxiosInstanceCreatorParams} param0
 */
export default function createAxiosInstance({
  apiToken,
  getIsBrazil,
  host,
  clientId,
  getSsoToken,
}) {
  const forgeRockAxiosInstance = axios.create({
    baseURL: host,
    responseType: 'json',
  });
  const authenticationInterceptor = createAuthenticationInterceptor({
    apiToken,
    getSsoToken,
  });
  const clientIdInterceptor = createClientIdInterceptor({
    clientId,
  });
  const realmPathInterceptor = createRealmPathInterceptor({
    getIsBrazil,
  });
  const dataSerializerInterceptor = createDataSerializerInterceptor();

  forgeRockAxiosInstance.interceptors.request.use(realmPathInterceptor);
  forgeRockAxiosInstance.interceptors.request.use(dataSerializerInterceptor);
  forgeRockAxiosInstance.interceptors.request.use(clientIdInterceptor);
  forgeRockAxiosInstance.interceptors.request.use(authenticationInterceptor);

  return forgeRockAxiosInstance;
}
